import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, MapPin, Calendar } from 'lucide-react';

const HeroSection = () => {
  return (
    <section 
      data-testid="hero-section"
      className="relative min-h-[85vh] flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: 'url(https://static.prod-images.emergentagent.com/jobs/48071dc7-c7ca-4c34-af70-815a4f5c8b60/images/b6194e813b0996b0a86e27d3db63e44f9ed286e4c4d6a8a15519b9b59dcb8eb7.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 hero-gradient"></div>
      
      <div className="relative z-10 container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-block mb-6">
              <span className="text-sm uppercase tracking-[0.2em] font-bold text-[#10B981] bg-[#10B981]/10 px-4 py-2 rounded-full">
                Investment Opportunity
              </span>
            </div>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white mb-6"
          >
            LIVENEAT Smart Vending Network
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="text-xl sm:text-2xl text-[#F3F0E6] mb-4 font-medium"
          >
            ₹10,00,000 Investment • <span className="text-[#F59E0B] font-bold">2X-3.5X Annual ROI</span>
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.5 }}
            className="mb-8 bg-white/10 backdrop-blur-md border border-white/30 rounded-xl p-4"
          >
            <p className="text-sm text-[#D1FAE5] leading-relaxed">
              <span className="font-semibold text-white">Revolutionizing Healthy Eating:</span> Be an early mover in the smart vending revolution, making nutritious food accessible 24/7 while building a sustainable, high-return asset portfolio.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8"
          >
            <div className="flex items-center space-x-3 glass-card rounded-xl p-4">
              <div className="bg-[#10B981] p-2 rounded-lg">
                <TrendingUp className="h-5 w-5 text-white" />
              </div>
              <div>
                <p className="text-sm text-[#4B5563] font-medium">Monthly Income</p>
                <p className="text-lg font-bold text-[#022C22] data-font">₹1.6L - ₹3L</p>
              </div>
            </div>

            <div className="flex items-center space-x-3 glass-card rounded-xl p-4">
              <div className="bg-[#10B981] p-2 rounded-lg">
                <MapPin className="h-5 w-5 text-white" />
              </div>
              <div>
                <p className="text-sm text-[#4B5563] font-medium">Locations</p>
                <p className="text-lg font-bold text-[#022C22]">Noida & Gurgaon</p>
              </div>
            </div>

            <div className="flex items-center space-x-3 glass-card rounded-xl p-4">
              <div className="bg-[#10B981] p-2 rounded-lg">
                <Calendar className="h-5 w-5 text-white" />
              </div>
              <div>
                <p className="text-sm text-[#4B5563] font-medium">Contract</p>
                <p className="text-lg font-bold text-[#022C22]">12 Months</p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.8 }}
            className="flex flex-col sm:flex-row gap-4"
          >
            <a 
              href="#contact" 
              className="inline-flex items-center justify-center bg-[#10B981] hover:bg-[#059669] text-white font-semibold px-8 py-4 rounded-full text-lg transition-all duration-300 hover:scale-105 shadow-lg"
            >
              Get Investor Pack
            </a>
            <a 
              href="#calculator" 
              className="inline-flex items-center justify-center bg-white/20 backdrop-blur-sm border-2 border-white text-white font-semibold px-8 py-4 rounded-full text-lg hover:bg-white/30 transition-all duration-300"
            >
              Calculate Returns
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
